import { AbilityBuilder, createMongoAbility } from "@casl/ability";
import type { SessionUser } from "./authenticator";
import type { MongoAbility } from "@casl/ability/dist/types/Ability";

type Actions = "manage" | "read" | "write";
type Subjects = "workspace" | "organization" | "rmor";
type AppAbility = MongoAbility<[Actions, Subjects]>;

export default function defineAbilityFor(user: SessionUser | null) {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);

  if (!user) {
    return build();
  }

  if (user.isSuperUser) {
    can("manage", "rmor");
    can("manage", "organization");
    can("manage", "workspace");
  }

  switch (user.role) {
    case "ORG_ADMIN":
      can("manage", "organization");
      can("manage", "workspace");
      break;
    case "ORG_EDITOR":
      can("read", "organization");
      can("read", "workspace");
      can("write", "workspace"); // Can edit results but not manage (launch scans)
      break;
    case "ORG_USER":
      can("read", "organization");
      can("read", "workspace");
      break;
    case "WORKSPACE_ADMIN":
      can("manage", "workspace");
    case "WORKSPACE_USER":
      can("read", "workspace");
      break;
    case "WORKSPACE_EDITOR":
      can("read", "workspace");
      can("write", "workspace"); // Can edit results but not manage (launch scans)
      break;
    case "WORKSPACE_VIEWER":
      can("read", "workspace");
      break;
  }

  return build();
}
